module.exports = __webpack_public_path__ + "static/media/reco_home_p.8c5aed36.gif";


//////////////////
// WEBPACK FOOTER
// ./src/projects/reco/src/reco_home_p.gif
// module id = 568
// module chunks = 0